export default {
  setAds(state, ads) {
    state.ads.list = ads;
  }
};
